import React from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";




export default function WorkshopInstructions({contact1, contact2, open, setOpen, filterInstructions}){


    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
          closeOnBlur
          active={open}
          onClose={() => {
            setOpen(false);
          }}
        >
            <Modal.Content>
                <Section style={{ backgroundColor: "white" }}>
                    <Title>Instructions</Title>
                    <Columns isMultiline>
                        <Column>
                            <h2>{contact1 ? contact1.display_name : ""} Instructions</h2>
                            <ul>
                                {contact1 && contact1.id && contact1.workshop_instructions.filter((instruction) => filterInstructions(instruction)).map((instruction) => (
                                    <li>{instruction.text}</li>
                                ))}
                            </ul>
                        </Column>
                        <Column>
                            <h2>{contact2 ? contact2.display_name : ""} Instructions</h2>
                            <ul>
                                {contact2 && contact2.id && contact2.workshop_instructions.filter((instruction) => filterInstructions(instruction)).map((instruction) => (
                                    <li>{instruction.text}</li>
                                ))}
                            </ul>
                        </Column>
                    </Columns>
                    <Button
                        color={"info"}
                        onClick={() => setOpen(false)}
                        isFullWidth
                    >
                        Close
                    </Button>
                </Section>
            </Modal.Content>
        </Modal>
    );


}